<template>
    <Head title="Register" />

    <jet-authentication-card>
        <div class="flex flex-col text-center w-full mb-4">
            <LogoAppSquare class="h-24 w-24 m-auto" />
        </div>

        <jet-validation-errors class="mb-4" />

        <form @submit.prevent="submit">
            <div>
                <jet-label for="fullname" value="Nama Perusahaan" />
                <jet-input
                    id="fullname"
                    type="text"
                    class="mt-1 block w-full"
                    v-model="form.fullname"
                    required
                    autofocus
                    autocomplete="fullname"
                />
            </div>
            <div class="mt-4">
                <jet-label for="identity" value="NPWP Perusahaan" />
                <InputMask
                    id="identity"
                    type="text"
                    class="mt-1 block w-full"
                    v-model="form.identity"
                    required
                    autofocus
                    autocomplete="identity"
                    mask="999.999.999.9-999.999"
                />
            </div>

            <div class="mt-4">
                <jet-label for="email" value="Email Perusahaan" />
                <jet-input
                    id="email"
                    type="email"
                    class="mt-1 block w-full"
                    v-model="form.email"
                    required
                />
            </div>

            <div class="mt-4">
                <jet-label for="username" value="Username" />
                <jet-input
                    id="username"
                    type="text"
                    class="mt-1 block w-full"
                    v-model="form.username"
                    required
                    autofocus
                    autocomplete="username"
                />
            </div>

            <div class="mt-4">
                <jet-label for="password" value="Password" />
                <jet-input
                    id="password"
                    type="password"
                    class="mt-1 block w-full"
                    v-model="form.password"
                    required
                    autocomplete="new-password"
                />
            </div>

            <div class="mt-4">
                <jet-label
                    for="password_confirmation"
                    value="Confirm Password"
                />
                <jet-input
                    id="password_confirmation"
                    type="password"
                    class="mt-1 block w-full"
                    v-model="form.password_confirmation"
                    required
                    autocomplete="new-password"
                />
            </div>

            <div
                class="mt-4"
                v-if="$page.props.jetstream.hasTermsAndPrivacyPolicyFeature"
            >
                <jet-label for="terms">
                    <div class="flex items-center">
                        <jet-checkbox
                            name="terms"
                            id="terms"
                            v-model:checked="form.terms"
                        />

                        <div class="ml-2">
                            Setuju dengan
                            <a
                                target="_blank"
                                :href="route('termsofservice')"
                                class="
                                    underline
                                    text-sm text-gray-600
                                    hover:text-gray-900
                                "
                                >Syarat dan Ketentuan</a
                            >
                            <!--and <a
                                target="_blank"
                                :href="route('policy.show')"
                                class="
                                    underline
                                    text-sm text-gray-600
                                    hover:text-gray-900
                                "
                                >Privacy Policy</a
                            >-->
                        </div>
                    </div>
                </jet-label>
            </div>
            <div class="mt-4" >
                <!--             -->
                <div class="sample-captcha">
                    <section class="data-box">
                        <jet-input
                            v-model="inputValue"
                            placeholder="submit your captcha"
                            class="input"
                            type="text"
                        />

                        <!--                        <pre class="data">{{ data }}</pre>-->
                    </section>

                    <section class="captcha-box">
                        <VueClientRecaptcha
                            :value="inputValue"
                            @getCode="getCaptchaCode"
                            @isValid="checkValidCaptcha"
                        />
                    </section>
                </div>

            </div>

            <div class="flex items-center justify-end mt-4">
                <Link
                    :href="route('login')"
                    class="
                        underline
                        text-sm text-blue-700
                        hover:text-[#4338CA]
                        font-semibold
                    "
                >
                    Already registered
                </Link>

                <jet-button
                    class="ml-4"
                    :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing"
                >
                    Register
                </jet-button>
            </div>
        </form>
    </jet-authentication-card>
</template>

<script>
import { defineComponent } from "vue";
import JetAuthenticationCard from "@/Jetstream/AuthenticationCard.vue";
import LogoAppSquare from "@/Logo/LogoAppSquare";
import JetButton from "@/Jetstream/Button.vue";
import JetInput from "@/Jetstream/Input.vue";
import JetCheckbox from "@/Jetstream/Checkbox.vue";
import JetLabel from "@/Jetstream/Label.vue";
import JetValidationErrors from "@/Jetstream/ValidationErrors.vue";
import { Head, Link } from "@inertiajs/inertia-vue3";
import {reactive, ref} from "@vue/reactivity";
import VueClientRecaptcha from "vue-client-recaptcha";
import InputMask from 'primevue/inputmask';

export default defineComponent({
    components: {
        Head,
        JetAuthenticationCard,
        LogoAppSquare,
        JetButton,
        JetInput,
        JetCheckbox,
        JetLabel,
        JetValidationErrors,
        Link,
        VueClientRecaptcha,
        InputMask,
    },

    data() {
        return {
            form: this.$inertia.form({
                fullname: "",
                identity: "",
                username: "",
                email: "",
                password: "",
                password_confirmation: "",
                terms: false,
            }),
        };
    },

    methods: {
        submit() {
            // cek captcha
            if (this.data.isValid) {
                console.log(this.form);
                this.form.post(this.route("register"), {
                    onFinish: () =>
                        this.form.reset("password", "password_confirmation"),
                });
            } else {
                alert("Captcha Salah");
            }
        },
    },
    setup() {
        /* pass value to captcha  */
        const inputValue = ref(null);

        const data = reactive({
            captchaCode: null,
            isValid: false,
        });
        const getCaptchaCode = (value) => {
            /* you can access captcha code */
            data.captchaCode = value;
        };
        const checkValidCaptcha = (value) => {
            /* expected return boolean if your value and captcha code are same return True otherwise return False */
            data.isValid = value;
            if (value) {

            }
        };
        return {
            inputValue,
            data,
            getCaptchaCode,
            checkValidCaptcha,
        };
    },
});
</script>
